module.exports = __webpack_public_path__ + "img/20170725.53faf845.png";